import {
  formatPrice,
  formatPriceRange,
} from '~/js/utilities/products-and-collections';

const computePrice = (variants, field, ignoreZeros) => {
  if (variants.length === 0) {
    return '\u200b';
  }

  if (variants.length === 1) {
    const price = variants[0][field];
    if (!price) return '';
    return formatPrice(price, ignoreZeros);
  }

  const minPrice = Math.min(
    ...variants.map((variant) => Number(variant[field]?.amount))
  );
  const maxPrice = Math.max(
    ...variants.map((variant) => Number(variant[field]?.amount))
  );
  const currencyCode = variants[0][field]?.currencyCode;

  if (!currencyCode) return '';

  return formatPriceRange(
    { amount: minPrice, currencyCode },
    { amount: maxPrice, currencyCode },
    ignoreZeros
  );
};

const getAnnouncementByText = (query) => {
  const wrappers = document.querySelectorAll('.dpd-announcement--wrapper');

  for (const wrapper of wrappers) {
    const span = wrapper.querySelector('.discount-exclusion');
    if (!span) continue;
    const text = span.textContent.trim();
    if (text.includes(query)) {
      return wrapper;
    }
  }

  return null;
};

async function waitUntil(predicate) {
  return await new Promise((resolve, reject) => {
    let max_wait_time = 10;
    const interval = setInterval(() => {
      if (predicate()) {
        resolve('foo');
        clearInterval(interval);
        return;
      }

      max_wait_time--;
      if (max_wait_time === 0) {
        reject();
      }
    }, 1000);
  });
}

const insertAdjacentElement = async (target, content, position) => {
  await waitUntil(() => {
    const targetEl = document.querySelector(target);
    return !!targetEl;
  })
    .then(() => {
      const targetEl = document.querySelector(target);

      if (targetEl) {
        targetEl.insertAdjacentElement(position, content);
      }
    })
    .catch(() => console.log('Error changing the element.'));
};

const heroProductInfo = () => ({
  get price() {
    return computePrice(this.parentSelectedVariants, 'price', false);
  },

  get priceRegular() {
    return computePrice(this.parentSelectedVariants, 'compareAtPrice', true);
  },

  get hasReducedPrice() {
    const { priceRegular, price } = this;
    return priceRegular && priceRegular !== price;
  },

  get pricingText() {
    return `reduced price: ${this.price}, regular price: ${this.priceRegular}`;
  },

  init() {
    // this.mutationObserver = new MutationObserver(() => {
    //   const afterpayPlacement = this.$refs.priceAfterpay.querySelector(
    //     'afterpay-placement,square-placement'
    //   );
    //   if (afterpayPlacement) {
    //     this.afterpayPlacement = afterpayPlacement;
    //   }
    // });

    // this.mutationObserver.observe(this.$refs.priceAfterpay, {
    //   childList: true,
    // });

    this.movePDPsCopys();
  },

  destroy() {
    this.mutationObserver.disconnect();
  },

  movePDPsCopys() {
    //this.handleFinalSaleText();
    //this.handleShippingText();
  },

  handleFinalSaleText() {
    const finalSale = getAnnouncementByText('Final Sale');

    if (finalSale) {
      insertAdjacentElement(
        '.hero-product-add__drawers',
        finalSale.cloneNode(true),
        'afterend'
      ).then(() => {
        finalSale.dataset.finalSale = 'true';
      });
    }
  },
  handleShippingText() {
    const shippingText = getAnnouncementByText('Ships Exclusively');
    const isUS = window.Shopify && Shopify.country === 'US';

    if (shippingText && !isUS) {
      insertAdjacentElement(
        '.product-variant-selection__option-values',
        shippingText.cloneNode(true),
        'afterend'
      ).then(() => {
        shippingText.dataset.shipsExclusively = 'true';
      });
    }
  },
});

export default heroProductInfo;
